var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCockpit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 22.497,
    viewBox: "0 0 40 22.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -112.02)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.142,117.878A20,20,0,0,0,0,132.02v2.451H15.25l.094-1.069a4.669,4.669,0,0,1,5.39-4.2l-1.906,2.633v2.683h2.344v-1.924l1.753-2.421c.082.066.162.134.24.205a4.661,4.661,0,0,1,1.491,3.025l.094,1.069H40V132.02A19.869,19.869,0,0,0,34.142,117.878Zm3.514,14.25H26.813a7.005,7.005,0,0,0-2.06-3.475c-.146-.134-.3-.261-.453-.381l4.907-6.778-1.9-1.374-5.094,7.037a7.021,7.021,0,0,0-9.027,4.972H2.344v-.108a17.656,17.656,0,0,1,30.141-12.485,17.54,17.54,0,0,1,5.171,12.485Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCockpit);
export default __webpack_public_path__ + "static/media/cockpit.ad271b44abb6267cdf2c5cd18aad8601.svg";
export { ForwardRef as ReactComponent };